package com.daytimegaming.ourdailyfinances.presentation.home

import androidx.lifecycle.ViewModel
import androidx.lifecycle.viewModelScope
import com.daytimegaming.ourdailyfinances.domain.model.User
import com.daytimegaming.ourdailyfinances.domain.model.UserProfile
import com.daytimegaming.ourdailyfinances.domain.repository.UserRepository
import com.daytimegaming.ourdailyfinances.domain.usecase.AuthUseCase
import com.daytimegaming.ourdailyfinances.data.settings.SettingsManager
import com.daytimegaming.ourdailyfinances.domain.billing.SubscriptionManager
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.SharingStarted
import kotlinx.coroutines.flow.StateFlow
import kotlinx.coroutines.flow.asStateFlow
import kotlinx.coroutines.flow.stateIn
import kotlinx.coroutines.launch

class SettingsViewModel(
    private val authUseCase: AuthUseCase,
    private val settingsManager: SettingsManager,
    private val userRepository: UserRepository,
    private val subscriptionManager: SubscriptionManager,
) : ViewModel() {

    val currentUserProfile: StateFlow<UserProfile?> = userRepository.currentUserProfile

    val currentUser: StateFlow<User?> = authUseCase.GetCurrentUser()
        .stateIn(
            scope = viewModelScope,
            started = SharingStarted.WhileSubscribed(5_000),
            initialValue = null
        )

    val purchaseState = subscriptionManager.purchaseState

    init {
        viewModelScope.launch {
            subscriptionManager.loadProducts()
        }
    }

    fun setAndroidActivity(activity: Any?) {
        subscriptionManager.setAndroidActivity(activity)
    }

    fun upgradeSubscription(tier: String) {
        viewModelScope.launch {
            val productId = if (tier.lowercase() == "premium") {
                "subscription_premium_monthly"
            } else {
                "subscription_standard_monthly"
            }
            subscriptionManager.buyProduct(productId)
        }
    }

    fun cancelSubscription() {
        viewModelScope.launch {
            try {
                userRepository.cancelSubscription()
            } catch (e: Exception) {
                // Ignore or retain local status
            }
        }
    }

    private val _isStaging = MutableStateFlow(settingsManager.isStaging())
    val isStaging: StateFlow<Boolean> = _isStaging.asStateFlow()

    val isDebug: Boolean = settingsManager.isDebug()

    fun setStaging(enabled: Boolean) {
        settingsManager.setStaging(enabled)
        _isStaging.value = enabled
    }

    fun signOut() {
        viewModelScope.launch {
            authUseCase.SignOutUser()
        }
    }
}

